import './index.css'
import React, { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Chip from "@mui/material/Chip";
import TuneIcon from "@mui/icons-material/Tune";
import BadgeIndicator from "../../../common/BadgeIndicator";
import InputSearch from "../../../common/InputSearch";
import { TicketsFilterFormModel } from "../../../../models/ticket.model";
import { useNavigate } from "react-router-dom";
import AddChip from "../../../common/ActionChip/AddChip";
import IndicatorChip from "../../../common/ActionChip/IndicatorChip";
import { NAMES_ES, TICKET_STATUS_ALL } from "../../../../assets/appConstants/constants";
import { ResetIcon } from "../../../common/Icons";
import { useTicketsFilterContext } from "../../../../context/TicketsFilterContext";
import { useProject } from "../../../../context/ProjectContext";


interface PrimaryMenuBarProps {
  handleOpenFilter: () => void
  setSearch: (filter: any) => void
  resetPrimaryFilter: () => void
  defaultSearchForm: TicketsFilterFormModel
}

const PrimaryMenuBar: React.FC<PrimaryMenuBarProps> = ({
  handleOpenFilter, setSearch, resetPrimaryFilter, defaultSearchForm }) => {

  const navigate = useNavigate()
  const { selectedProject, isProjectUndefined } = useProject()
  const { appliedFilters } = useTicketsFilterContext()

  const [searchForm, setSearchForm] = useState<TicketsFilterFormModel>(defaultSearchForm)

  const handleSearchForm = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchForm({
      ...searchForm,
      [event.target.name]: event.target.value
    });
  }

  useEffect(() => resetSearchForm(), [selectedProject])

  const resetSearchForm = () => {
    setSearchForm({
      ...defaultSearchForm,
      'project_id': selectedProject,
      'status': TICKET_STATUS_ALL,
      'number': ''
    })
  }

  const onSubmitSearch = () => {
    setSearch(searchForm)
    resetSearchForm()
  }

  const onResetSearch = () => {
    resetSearchForm()
  }

  const onResetFilters = () => {
    resetPrimaryFilter()
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="tickets-listing-primarybar-box" >
        <div className="tickets-listing-primarybar-left">
          <span className="tickets-listing-searchtkt">
            <InputSearch
              name='number'
              value={searchForm.number}
              placeholder="Número de Ticket"
              onChange={handleSearchForm}
              onSubmitSearch={onSubmitSearch}
              onResetSearch={onResetSearch}
            />
          </span>

          {(appliedFilters.length > 0) && (
            <div className="tickets-listing-primarybar-left__sep"><p>|</p></div>
          )}

          {appliedFilters.map((item, index) => (
            <div key={index}>
              <IndicatorChip
                label={<span>
                  <span className="applied-filters__name">{NAMES_ES[item.key]}:</span> {item.value}
                </span>} />
            </div>
          ))
          }

          {(
            <ResetIcon onClick={onResetFilters} className="applied-filters__reset" />
          )}
        </div>

        {(!isProjectUndefined()) && (

          <div className="tickets-listing-actions-toolbar__item-right">
            <BadgeIndicator
              element={(<Chip
                icon={<TuneIcon color="success" />}
                label="Filtros"
                clickable
                onClick={handleOpenFilter} />)
              }
              indicator={appliedFilters.length === 0 ? null : appliedFilters.length}
            />

            <AddChip
              onClick={() => navigate('/ticket/create')}
              label='Nuevo Ticket'
            />

          </div>
        )}

      </div>

    </React.Fragment>
  );
}

export default PrimaryMenuBar
